import React, { useState } from 'react';
import { Button, Table } from 'antd';
import UseEditColumns from '@/component/UseEditColumns/UseEditColumns';

const TestPage = () => {
  // 模拟测试数据
  const [dataSource] = useState([
    {
      id: 1,
      name: '张三',
      age: 25,
      email: 'zhangsan@example.com',
      department: '技术部',
      position: '前端工程师',
      salary: 8000,
      status: 'active'
    },
    {
      id: 2,
      name: '李四',
      age: 28,
      email: 'lisi@example.com',
      department: '产品部',
      position: '产品经理',
      salary: 12000,
      status: 'active'
    },
    {
      id: 3,
      name: '王五',
      age: 30,
      email: 'wangwu@example.com',
      department: '设计部',
      position: 'UI设计师',
      salary: 9000,
      status: 'inactive'
    }
  ]);

  // 初始列配置
  const [columns, setColumns] = useState([
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      visible: true,
      width: 80,
      sorter: true
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      visible: true,
      width: 120
    },
    {
      title: '年龄',
      dataIndex: 'age',
      key: 'age',
      visible: true,
      width: 80,
      sorter: true
    },
    {
      title: '邮箱',
      dataIndex: 'email',
      key: 'email',
      visible: true,
      width: 200
    },
    {
      title: '部门',
      dataIndex: 'department',
      key: 'department',
      visible: true,
      width: 120
    },
    {
      title: '职位',
      dataIndex: 'position',
      key: 'position',
      visible: true,
      width: 150
    },
    {
      title: '薪资',
      dataIndex: 'salary',
      key: 'salary',
      visible: false,
      width: 100,
      sorter: true
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      visible: true,
      width: 100,
      render: (status) => (
        <span style={{ color: status === 'active' ? 'green' : 'red' }}>
          {status === 'active' ? '在职' : '离职'}
        </span>
      )
    }
  ]);

  // 使用UseEditColumns组件
  const { show, WscEditColumnsModal } = UseEditColumns({
    topic: 'test-table',
    colsettings: columns,
    list: dataSource
  });

  // 处理列配置更新
  const handleColumnsUpdate = (newSettings) => {
    console.log('更新后的列配置:', newSettings);
    setColumns(newSettings);
  };

  // 过滤显示的列
  const visibleColumns = columns.filter(col => col.visible);

  return (
    <div style={{ padding: '20px' }}>
      <h2>UseEditColumns 组件测试页面</h2>
      
      <div style={{ marginBottom: '16px' }}>
        <Button type="primary" onClick={show}>
          配置表头
        </Button>
      </div>

      <Table
        dataSource={dataSource}
        columns={visibleColumns}
        rowKey="id"
        pagination={false}
        bordered
        size="small"
      />

      <WscEditColumnsModal
        onFinish={handleColumnsUpdate}
      />

      <div style={{ marginTop: '20px' }}>
        <h3>当前列配置:</h3>
        <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
          {JSON.stringify(columns, null, 2)}
        </pre>
      </div>
    </div>
  );
};

export default TestPage;